module.exports = __webpack_public_path__ + "static/img/lawLibrary.70c97d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout/lawLibrary.png
// module id = 8GTE
// module chunks = 34